import moment from "moment";
import { Page, Text, View, Document, Image, StyleSheet } from "@react-pdf/renderer";
import { imageBaseUrl } from "../../../../utils/utils";

const styles = StyleSheet.create({
    page: {
        padding: 20,
        fontSize: 10,
        lineHeight: "13px"
    },
    header: {
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: 10,
    },
    border: {
        paddingBottom: 20,
        borderBottomWidth: 1,
        borderBottomColor: "black",
    },
    logo: {
        width: "160px",
        height: "40px",
    },
    stamp: {
        width: "400px",
        height: "250px",
        objectFit: "contain"
    },
    section: {
        marginBottom: 10,
    },
    footer: {
        marginTop: 20,
        paddingTop: 10,
    },
    gridContainer: {
        flexDirection: "row",
        justifyContent: "space-evenly",
        flexWrap: "wrap",
        marginTop: 20,
        gap: 10,
    },
    gridItem: {
        flex: 1,
        minWidth: "30%",
        paddingRight: 8,
    },
    margin: {
        marginBottom: "10px",
    },
    imageColumn: {
        width: "15%",
        textAlign: "center",
    },
    nameColumn: {
        width: "25%",
        textAlign: "left",
    },
    quantityColumn: {
        width: "10%",
        textAlign: "right",
    },
    unitPriceColumn: {
        width: "15%",
        textAlign: "right",
    },
    amountColumn: {
        width: "15%",
        textAlign: "right",
    },
    tableImage: {
        width: 50,
        height: 50,
        objectFit: "contain",
    },
    table: {
        marginTop: 10,
        borderColor: "#B0B0B0",
        borderLeftWidth: 1,
        borderTopWidth: 1,
        display: "table",
        width: "100%",
    },
    tableRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderColor: "#B0B0B0",
    },
    tableCell: {
        flex: 1,
        borderRightWidth: 1,
        borderColor: "#B0B0B0",
        padding: 5,
        textAlign: "center",
    },
    tableHeader: {
        backgroundColor: "#f2f2f2",
        borderBottomWidth: 1,
        borderColor: "#B0B0B0",
    },
    container: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        marginBottom: 10,
    },
    rowEven: {
        backgroundColor: "#fff"
    },
    rowOdd: {
        backgroundColor: "#f9f9f9"
    }
});

const CrmProductPdf = ({ data }) => {
    console.log("pdffffffff", data.color)

    return (
        <Document>
            <Page style={styles.page} size="A4">
                {/* Header */}
                <View style={[styles.header, styles.border]}>
                    <Text style={{ fontSize: 16, color: "black" }}>ASM</Text>
                    <Text style={{ fontSize: 14, color: "black", marginTop: 20 }}>ITEM PURCHASE ORDER</Text>
                </View>

                {/* Details */}
                <View style={[styles.gridContainer, styles.border]}>
                    <View style={styles.gridItem}>
                        {[
                            ["Buyer", "AMBER SILK MILLS"],
                            ["Supplier", data?.suppiler],
                            ["Size", data?.size],
                            ["Fabricator", data?.fabricator],
                            ["Style No", data?.style_no],
                            ["Style Name", data?.style_name],
                            ["Remarks", data?.remarks]
                        ].map(([label, value], i) => (
                            <View key={i} style={{ flexDirection: "row" }}>
                                <Text style={{ fontSize: 11, marginTop: 5 }}>{label}</Text>
                                <Text style={{ fontSize: 11, marginTop: 5, marginLeft: 8 }}>: {value || "N/A"}</Text>
                            </View>
                        ))}
                    </View>

                    <View style={styles.gridItem}>
                        {[
                            ["Order No", data?.order_no],
                            ["Dated", data?.dated ? moment(data.dated).format("DD-MM-YYYY") : null],
                            ["Order Date", data?.delivery_date ? moment(data.delivery_date).format("DD-MM-YYYY") : null],
                            ["Delivery at", data?.delivery_at],
                            ["Issue Qty", data?.issue_quantity]
                        ].map(([label, value], i) => (
                            <View key={i} style={{ flexDirection: "row" }}>
                                <Text style={{ fontSize: 11, marginTop: 5 }}>{label}</Text>
                                <Text style={{ fontSize: 11, marginTop: 5, marginLeft: 8 }}>: {value || "N/A"}</Text>
                            </View>
                        ))}
                    </View>
                </View>

                {/* Extra info */}
                <View style={{ flexDirection: "row", marginTop: 10 }}>
                    <Text>Color: </Text>
                    {data?.color?.map((i, index) => (
                        <Text key={index}>{i}
                            {index < data.color.length - 1 && ', '}</Text>
                    ))}

                </View>

                {/* Product Table */}
                <View style={styles.table}>
                    <View style={[styles.tableRow, styles.tableHeader]}>
                        <Text style={[styles.tableCell, styles.nameColumn]}>Name</Text>
                        <Text style={[styles.tableCell, styles.imageColumn]}>Avg(1 Pcs)</Text>
                        <Text style={[styles.tableCell, styles.nameColumn]}>1 Col. Qty</Text>
                        <Text style={[styles.tableCell, styles.quantityColumn]}>Quantity</Text>
                        <Text style={[styles.tableCell, styles.unitPriceColumn]}>Unit</Text>
                        <Text style={[styles.tableCell, styles.amountColumn]}>Rate</Text>
                        {/* <Text style={[styles.tableCell, styles.amountColumn]}>Total</Text> */}
                    </View>

                    {data?.itemId?.item && data?.itemId?.item.map((item, index) => {
                        const issueQty = parseFloat(data?.issue_quantity) || 0;
                        const avg = parseFloat(item.avg_pics) || 0;
                        const totalColor = data?.color?.length || 0;

                        const colQty = totalColor > 0 ? (issueQty / totalColor) * avg : 0;
                        const quantity = colQty * totalColor;

                        return (
                            <View key={index} style={[styles.tableRow, index % 2 === 0 ? styles.rowEven : styles.rowOdd]}>
                                <Text style={[styles.tableCell, styles.nameColumn]}>{item.item_name || "N/A"}</Text>
                                <Text style={[styles.tableCell, styles.imageColumn]}>{avg.toFixed(2)}</Text>

                                <Text style={[styles.tableCell, styles.nameColumn]}>
                                    {`${colQty.toFixed(2)}${totalColor > 0 ? " *" + totalColor : ""}`}
                                </Text>

                                <Text style={[styles.tableCell, styles.quantityColumn]}>
                                    {quantity.toFixed(2)}
                                </Text>

                                <Text style={[styles.tableCell, styles.unitPriceColumn]}>{item.unit || "N/A"}</Text>
                                <Text style={[styles.tableCell, styles.amountColumn]}>
                                    ₹{parseFloat(item.rate || 0).toFixed(2)}
                                </Text>
                            </View>
                        );
                    })}


                </View>


                {/* Total Section */}
                {/* <View style={[styles.border, { flexDirection: "row", justifyContent: "flex-end", marginTop: 20 }]}>
                    <Text>
                        Total: {data?.total != null ? `₹${Math.round(parseFloat(data.total))}` : "N/A"}
                    </Text>
                </View> */}

                {/* Product Image */}
                {data?.itemId?.style_image && (
                    <View style={{ flexDirection: 'row', justifyContent: 'flex-start', marginTop: 20 }}>
                        <Image src={`${imageBaseUrl}images/${data?.itemId?.style_image}`} style={styles.stamp} />
                    </View>
                )}

                {/* Signature */}
                <View style={{ flexDirection: 'row', justifyContent: 'flex-end', marginTop: 75, marginRight: 10 }}>
                    <Text style={{ borderTopWidth: 1, borderColor: 'black', paddingTop: 5 }}>
                        Authorized Sign
                    </Text>
                </View>
            </Page>
        </Document>
    );
};

export default CrmProductPdf;
